import React from "react";
import ComputerRoundedIcon from "@mui/icons-material/ComputerRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import trackingPhone from "assets/img/premium-tracking-phone.jpg";

const steps = [
  { number: 1, title: "Book a Shipment", text: "Fill in your cargo details in minutes.", Icon: ComputerRoundedIcon, accent: "blue" },
  { number: 2, title: "Get Matched", text: "We connect you with verified fleet providers.", Icon: GroupsRoundedIcon, accent: "orange" },
  { number: 3, title: "Track in Real-Time", text: "Monitor your shipment every step of the way.", Icon: LocationOnRoundedIcon, accent: "green" },
  { number: 4, title: "Delivery Complete", text: "Safe, on-time, hassle-free.", Icon: TaskAltRoundedIcon, accent: "purple" }
];

export default function HowItWorks() {
  return (
    <section className="pl-how pl-section pl-reveal" id="how-it-works" aria-labelledby="pl-how-title">
      <div className="pl-container pl-how__inner">
        <div className="pl-how__content">
          <p className="pl-eyebrow pl-eyebrow--light">How it works</p>
          <h2 id="pl-how-title">Logistics Made Simple</h2>
          <ol className="pl-step-list">
            {steps.map(({ number, title, text, Icon, accent }, index) => (
              <li key={title}>
                <div className="pl-step__top">
                  <span className={`pl-step__number pl-step__number--${accent}`}>{number}</span>
                  <Icon aria-hidden="true" />
                  {index < steps.length - 1 ? <ArrowForwardRoundedIcon className="pl-step__arrow" aria-hidden="true" /> : null}
                </div>
                <h3>{title}</h3>
                <p>{text}</p>
              </li>
            ))}
          </ol>
        </div>

        <div className="pl-how__visual">
          <img
            src={trackingPhone}
            alt="Mobile phone displaying a generic shipment tracking route"
            width="1024"
            height="1536"
            loading="lazy"
          />
          <div className="pl-how__message">
            <strong>Real-time<br />tracking<br />at your<br />fingertips</strong>
            <span aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
}
